<p class="default-label">
  Please select a collection to begin submission process
</p>
